export default class Nav {
    constructor($el) {
        this.$el = $el;
        this.$menuOverlay = this.$el.querySelector('.js-navMenuOverlay');
        this.$menuToggle = this.$el.querySelector('.js-navMenuToggle');
        this.initListeners();
    }

    initListeners() {
        this.$menuToggle.addEventListener('click', () => {
            const isExpanded = this.$menuToggle.getAttribute('aria-expanded') === 'false';
            this.$menuToggle.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
        });

        this.$menuOverlay.addEventListener('click', () => {
            this.$menuToggle.setAttribute('aria-expanded', 'false');
        });

        const onScroll = () => {
            this.$el.classList.toggle('is-scrolled', window.scrollY >= 16);
        };

        window.addEventListener('scroll', onScroll);
        onScroll();
    }
}
